export class MensagemConstante
{
    public static msgErroClientSideRodape: string = 'Caso seja necessário abrir um incidente, forneça o código exibido no início da mensagem.';
    public static msgErroClientSideCabecalho: string = 'Não foi possível processar sua solicitação.';
    public static msgErroClientSideAcessoNegado: string = 'Acesso não autorizado.';
}
